import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { forwardRef, memo, useEffect, useState } from "react";
import { Button, Grid, Menu, Select, Space, Text } from "@mantine/core";
import { IconChevronDown } from "@tabler/icons";
import { SECONDARY_COLOR } from "../theme/button";
const SelectItem = forwardRef(({ label, ...others }, ref) => (_jsx("div", { ref: ref, ...others, children: _jsx(Text, { size: "sm", children: label }) })));
const SortSelect = ({ selected, sortOptions, onChange, ...props }) => {
    return (_jsx(Select, { label: "Sort by", placeholder: "Pick one", itemComponent: SelectItem, data: sortOptions, value: selected === null || selected === void 0 ? void 0 : selected.value, onChange: (key) => onChange(key), maxDropdownHeight: 400, styles: {
            icon: {
                color: "black",
            },
        }, ...props }));
};
export const DEFAULT_SORT_CHOICE = {
    value: "",
    descending: true,
};
const SortOptions = ({ selected, options, apply, reset, children, }) => {
    const [sortChoice, setSortChoice] = useState();
    useEffect(() => {
        setSortChoice(selected);
    }, [selected]);
    return (_jsxs(Menu, { transition: "pop-top-right", position: "bottom-end", radius: 14, shadow: "sm", onClose: () => setSortChoice(selected), children: [_jsx(Menu.Target, { children: _jsx(Button, { color: SECONDARY_COLOR, rightIcon: _jsx(IconChevronDown, { size: 16 }), px: "sm", mt: 12, ml: 8, children: "Sort & Filter" }) }), _jsxs(Menu.Dropdown, { style: {
                    border: 0,
                    padding: 8,
                }, children: [children, _jsx(SortSelect, { sortOptions: options, selected: sortChoice, onChange: (newSortChoiceLabel) => {
                            const choice = options.find((s) => s.value === newSortChoiceLabel);
                            if (!choice) {
                                reset();
                            }
                            else {
                                setSortChoice({
                                    value: choice.value,
                                    descending: choice.descending,
                                });
                            }
                        } }), _jsx(Space, { h: "sm" }), _jsxs(Grid, { children: [_jsx(Grid.Col, { span: 6, children: _jsx(Button, { color: SECONDARY_COLOR, onClick: reset, children: "Reset" }) }), _jsx(Grid.Col, { span: 6, children: _jsx(Button, { onClick: () => {
                                        if (sortChoice)
                                            apply === null || apply === void 0 ? void 0 : apply(sortChoice);
                                    }, children: "Apply" }) })] })] })] }));
};
export default memo(SortOptions);
